export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/LogoutBlack.1604f9db.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};